import axiosInstance from "./client";
import { convertCurrencyStringToNumber, isObjectEmpty } from "~/utils";

// Types
import {
  TTransactionAddData,
  TTransactionData,
  TTransactionEditData,
} from "~/types";

export const getTransactionList = async ({
  walletId,
  year,
  month,
  week = 5,
}: {
  walletId: string;
  year: string | number;
  month: string | number;
  week: string | number;
}) => {
  let ret: any = {};
  const response = await axiosInstance.get(
    `/transaction/month?walletInforID=${walletId}&year=${year}&month=${month}&weekOfMonth=${week}`
  );

  const transactions = response?.data;

  if (!isObjectEmpty(transactions)) {
    for (let date in transactions) {
      ret[`${date}`] = transactions[date];
    }
  }

  return ret;
};

export const getTransactionInfo = async (
  id: string
): Promise<TTransactionData> => {
  let ret = [];
  const response = await axiosInstance.get(
    `/transaction/details?transactionID=${id}`
  );
  ret = response.data;
  return {
    username: ret.username,
    id: ret.transactionID,
    amount: ret.amount,
    photo: ret.photo,
    categoryName: ret.categoryName,
    categoryIcon: ret.categoryIcon,
    categoryId: ret.categoryID,
    note: ret.note,
    transactionDate: ret.transactionDate,
    excludeFromReport: ret.excludeFromReport,
    eventName: ret.eventName,
  };
};

export const editTransaction = async (data: TTransactionEditData) => {
  const response = await axiosInstance.put(`/transaction/update`, {
    walletInforID: data.walletId,
    amount: data.amount,
    categoryID: data.categoryId,
    note: data.note,
    transactionDate: data.transactionDate,
    excludeFromReport: data.excludeFromReport,
    eventID: data.eventId,
    remindAt: data.remindAt,
    transactionID: data.transactionId,
  });

  return response;
};

export const addTransaction = async (data: TTransactionAddData) => {
  let transactionData: any;
  transactionData = {
    walletInforID: data.walletId,
    categoryID: data.categoryId,
    transactionDate: data.transactionDate,
    excludeFromReport: data.excludeFromReport,
    remindAt: data.remindAt,
  };

  if (data.amount !== "0") {
    transactionData.amount = convertCurrencyStringToNumber(data.amount);
  }

  if (data.note) {
    transactionData.note = data.note;
  }

  if (data.eventId) {
    transactionData.eventID = data.eventId;
  }

  const response = await axiosInstance.post(
    `/transaction/create`,
    transactionData
  );

  return response;
};

export const deleteTransaction = async (transactionId: string) => {
  const response = await axiosInstance.delete(
    `/transaction/delete?transactionID=${transactionId}`
  );
  return response;
};
